import { useTranslation } from 'react-i18next';

import { StyledWeekdayChip, StyledWeekdays } from './WeekdaysPicker.styles';
import type { Weekdays, WeekdaysPickerProps } from './WeekdaysPicker.types';

const DAYS: { key: keyof Weekdays; label: string }[] = [
  { key: 'monday', label: 'weekday.mo' },
  { key: 'tuesday', label: 'weekday.tu' },
  { key: 'wednesday', label: 'weekday.we' },
  { key: 'thursday', label: 'weekday.th' },
  { key: 'friday', label: 'weekday.fr' },
  { key: 'saturday', label: 'weekday.sa' },
  { key: 'sunday', label: 'weekday.su' }
];

/**
 * Seven toggles, one per weekday. A selected day is a filled chip: the SDB theme draws every
 * outlined chip in the same surface colour whatever its colour prop, so colour alone does not show
 * the selection.
 */
export default function WeekdaysPicker({
  value,
  onChange
}: WeekdaysPickerProps) {
  const { t } = useTranslation();

  // A new object, so a form that compares by reference sees the change.
  const toggle = (day: keyof Weekdays) =>
    onChange({ ...value, [day]: !value[day] });

  return (
    <StyledWeekdays>
      {DAYS.map(({ key, label }) => (
        <StyledWeekdayChip
          key={key}
          clickable
          size="small"
          label={t(label)}
          onClick={() => toggle(key)}
          variant={value[key] ? 'filled' : 'outlined'}
          color={value[key] ? 'primary' : 'default'}
          aria-pressed={value[key]}
        />
      ))}
    </StyledWeekdays>
  );
}
